<template>
  <div class="forms">
    <div class="h2">
      <div class="mid">
        <a-radio-group v-model='type' @change="resh()">
          <a-radio :value="0">拍卖中({{ top.auctionCount }})</a-radio>
          <a-radio :value="1">即将拍卖({{ top.auctionWillCount }})</a-radio>
        </a-radio-group>
        <a-col class="flex" :span="4">
          <label>债务人：</label>
          <a-input v-model="form.debtor_name" placeholder="请输入债务人"></a-input>
        </a-col>
        <a-col class="flex" :span="5">
          <label>债务人证件号码：</label>
          <a-input v-model="form.debtor_chinaid" placeholder="请输入证件号码"></a-input>
        </a-col>
        <a-col class="flex">
          <label>拍卖状态：</label>
          <a-select v-model="form.auction_status" placeholder="请选择" class="select" style="width:140px;"
            :allowClear='true'>
            <a-select-option :value="1">即将开始</a-select-option>
            <a-select-option :value="2">扣押中</a-select-option>
            <a-select-option :value="3">拍卖中</a-select-option>
            <!-- <a-select-option :value="4">已拍卖</a-select-option> -->
            <a-select-option :value="5">流拍</a-select-option>
          </a-select>
        </a-col>
        <div class="find">
          <a-button type="primary" icon="search" @click="resh()" style="margin-left: 20px;">查询</a-button>
          <a-button @click="reset" style="margin-left: 10px;">重置</a-button>
          <!-- <a-button type="primary" icon="plus" @click='edit=1;disType=2;visible=true;'>新增</a-button> -->
        </div>
      </div>
    </div>
    <div class="table" v-if='load'>
      <Table :getUrl='putData.url[type]' :formKey='putData.formKey' ID='id' ref='table' :query='form'
        :other='["debtor_id"]' :backAll="true" v-if='$common.AUTH("welcome:sell")'>
        <template v-slot:pick='v'>
          <div class="fbtns">
            <a href="javascript:void(0);" @click="link(v)" style="margin-right:10px;">查看</a>
            <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="read(v)">
              <a href="javascript:void(0);" v-if="type == 0">关闭提醒</a>
            </a-popconfirm>
          </div>
        </template>
      </Table>
      <div class="nqx smnq" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import Table from './table.vue'
import { auctionAdd } from '@/server/debtor'
export default {
  name: 'Auction',
  props: {
    putData: Object,
    NumList: Array
  },
  data() {
    return {
      load: true,
      type: 0,
      form: {
        auction_status: undefined,
        debtor_realname: '',
        debtor_chinaid: '',
      }
    }
  },
  components: { Table },
  computed: {
    top() {
      return this.$store.state.Home.Top
    }
  },
  methods: {
    link(obj) {
      //let name=obj.debtor_id?'lydetails':'ldetails',id=obj.debtor_id?obj.debtor_id:obj.letters_debtor_id
      let routeUrl = this.$router.resolve({ "name": 'lydetails', params: { "id": obj.other[0] } });
      window.open(routeUrl.href, '_blank');
    },
    read(obj) {
      auctionAdd({ id: obj.id }).then(e => {
        this.$store.dispatch('Home/seth')
        this.$message.success({
          content: '关闭成功'
        })
        this.$refs.table.resh()
        this.$store.dispatch('Home/getKey', this.NumList)
      })
    },
    async resh() {
      let p = (bool) => new Promise((resolve, reject) => {
        this.load = bool;
        resolve()
      })
      await p(false)
      await p(true)
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.type = 0
      this.form.debtor_name = ''
      this.form.debtor_chinaid = ''
      this.form.auction_status = undefined
      this.resh()
    }
  }
}
</script>
<style lang="less">
.fbtns {
  display: flex;

  span {
    font-size: 14px;
    color: #1d8bfe;
    display: inline-block;
    padding-right: 10px;
    position: relative;
    cursor: pointer;
  }
}
</style>
<style lang="less" scoped>
.btns {
  padding-top: 20px;
  text-align: center;
}

.row {
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
    color: #333;
    width: 80px;
  }
}

.mrow {
  margin-bottom: 20px;
}

.disform {

  .fintbox {
    display: flex;
    align-items: center;
    position: relative;

    .icons {
      font-size: 20px;
      color: #2196f3;
      cursor: pointer;
      margin-left: 10px;
    }

    a {
      position: absolute;
      right: 34px;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      overflow: hidden;
      height: 32px;
      margin-right: 2px;

      span {
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 32px;
      }
    }

    .log {
      width: 200px;

      span {
        width: 200px;
      }
    }

    .fbox {
      position: relative;
      color: #1d8bfe;
      white-space: nowrap;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}

.mid {
  display: flex;
  align-items: center;

  .flex {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-right: 10px;
  }

  .select {
    width: 80px;
  }

  .find {
    display: flex;
    align-items: center;

    /deep/.input {
      width: 132px;
      height: 30px;

      input {
        padding: 4px 8px;
        height: 30px;
        font-size: 13px;
        line-height: 30px;
      }
    }

    /deep/.ant-btn {
      height: 30px;
      margin-left: 2px;
    }
  }
}

b.err {
  color: #f00;
}
</style>